import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Input, message, Modal, Row, Space, Spin, Upload } from 'antd';
import { getClientConfig, isEmpty } from '../../generalFunctions';
import { PDFDownloadLink } from '@react-pdf/renderer';
import EmailDownloadAttachment from '../pdf/common/EmailDownloadAttachment';
import useApi from '../../hooks/useApi';
import { API_METHODS } from '../../constants';
import { UploadOutlined } from '@ant-design/icons';

const EmailModal = (props) => {
    const { visible, close, refresh, accountId, record, attachmentType, isClassified, attachmentName } = props;
    const [form] = Form.useForm();
    const { account } = getClientConfig();
    const [visibleCcNBcc, setVisibleCcNBcc] = useState(false);
    const [attachment, setAttachment] = useState();
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [response, request] = useApi("/mail/sendMail", null, API_METHODS.POST);
    const uploadProps = {
        name: 'file',
        multiple: true,
        onChange: (info) => {
            let files = info.fileList ? info.fileList : [info.file];
            let fileList = [...uploadedFiles, ...files];
            setUploadedFiles(fileList);
        },
        beforeUpload: (file) => { return false }
    };

    const sendEmail = () => {
        form.validateFields().then((values) => {
            values.to = values.to.includes(",") ? values.to.split(",") : values.to;
            values.cc = !isEmpty(values.cc) && values.cc.includes(",") ? values.cc.split(",") : values.cc;
            values.bcc = !isEmpty(values.bcc) && values.bcc.includes(",") ? values.bcc.split(",") : values.bcc;
            values.type = attachmentType;
            values.updateId = record.id;

            //extra files
            uploadedFiles.push(attachment);
            let files = [];
            uploadedFiles.forEach(file => {
                let reader = new FileReader();
                file = file.originFileObj ? file.originFileObj : file;
                reader.readAsDataURL(file);
                reader.onloadend = function () {
                    let base64data = reader.result;
                    let fileData = {}
                    fileData.content = base64data.split(",")[1];
                    fileData.filename = file.name ? file.name : attachmentType + ".pdf";
                    fileData.encoding = 'base64';
                    files.push(fileData);
                    if (files.length === uploadedFiles.length) {
                        values.attachment = files;
                        request(values);
                    }
                }
            });
        })
    }

    const handleShowCcNBcc = () => {
        const flag = visibleCcNBcc ? false : true;
        setVisibleCcNBcc(flag);
    }

    const getEmailMessageByType = (attachmentType) => {
        switch (attachmentType) {
            case "ReleaseOrder":
                return `Please find attachment for Release Order`
            case "Receipt":
                return `Received from Pushkar Deshpande sum of Rs. five thousand five hundred two only through NEFT for Bill Number(s) 38,39 date 2023-03-26`
        }
    }

    useEffect(() => {
        if (response.data && !response.isLoading) {
            message.success("Email Sent successfully.");
            close();
            refresh();
        } else if (response.error && !response.isLoading) {
            message.error("Unable to Send Email. Please try again.");
        }
    }, [response]);

    useEffect(() => {
        if (visible) {
            const accountInfo = account.find(a => a.id === accountId);
            const initialValues = {}
            initialValues.subject = attachmentType;
            initialValues.to = !isEmpty(accountInfo?.emailId) ? accountInfo.emailId : undefined;
            initialValues.message = getEmailMessageByType(attachmentType);
            form.setFieldsValue(initialValues);
        }
    }, [visible]);

    return (
        <Modal
            title="Send Email"
            open={visible}
            width={1250}
            onCancel={close}
            footer={null}
            maskClosable={false}
        >
            <Spin size='large' spinning={response?.isLoading}>
                <Card>
                    <Form form={form} layout='vertical'>
                        <Form.Item
                            label="SUBJECT"
                            name="subject"
                            rules={[{ required: true, message: 'Please enter subject!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="TO"
                            name="to"
                            rules={[{ required: true, message: 'Please enter email!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item>
                            <Button type='link' style={{ float: 'right' }} onClick={handleShowCcNBcc}>add cc & bcc</Button>
                        </Form.Item>
                        {visibleCcNBcc && <>
                            <Form.Item
                                label="CC"
                                name="cc">
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label="BCC"
                                name="bcc">
                                <Input />
                            </Form.Item>
                        </>}
                        <Form.Item
                            label="Message"
                            name="message">
                            <Input.TextArea maxLength={10000} autoSize={{ minRows: 7, maxRows: 9 }} />
                        </Form.Item>
                        <Row gutter={16}>
                            <Col span={6}>
                                <PDFDownloadLink document={<EmailDownloadAttachment attachmentType={attachmentType} data={record} isClassified={isClassified} />} fileName={attachmentName + ".pdf"}>
                                    {({ blob, url, loading, error }) => {
                                        setAttachment(blob);
                                        return loading ? 'Loading document...' : `${attachmentName}.pdf (click to download)`
                                    }
                                    }
                                </PDFDownloadLink>
                            </Col>
                            <Col span={6}>
                                <Upload {...uploadProps}>
                                    <Button icon={<UploadOutlined />}>Attach</Button>
                                </Upload>
                            </Col>
                        </Row>
                        <Space style={{ float: 'right' }}>
                            <Button type="primary" onClick={sendEmail}>
                                Send
                            </Button>
                            <Button type="primary" onClick={close}>
                                Cancel
                            </Button>
                        </Space>
                    </Form>
                </Card>
            </Spin>
        </Modal>
    );
}

export default EmailModal;